var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{ref:"containerPreview"},[_c('v-responsive',{directives:[{name:"resize",rawName:"v-resize",value:(_vm.updateSize),expression:"updateSize"}],attrs:{"aspect-ratio":16 / 9}},[_c('div',{attrs:{"id":"wrap"}},[_c('iframe',{style:(_vm.style),attrs:{"id":"frame","src":_vm.previewUrl}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }